import React from 'react';
// import {TextField } from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import { green } from '@material-ui/core/colors';

import Liste from '../Codification/Liste';
import MyDateField from '../Codification/MyDateField';
import util from '../../utils/util';

export default function ListeChargementVehicule(){
    const [chargements,setChargements] = React.useState([]);
    const history = useHistory();
   
    const colonnes = [
        { title: 'Date', field: 'date_achat', type:'date',
            filterComponent: props =>
            <MyDateField 
                name="date_achat"
                value={props.columnDef.tableData.filterValue||""}
                onChange={e=>{
                    props.columnDef.tableData.filterValue = e.target.value;
                    props.onFilterChanged(props.columnDef.tableData.columnOrder,e.target.value)
                }}
                errors={[]}
                label=" "
            />
        },
        { title: 'Code', field: 'code' },
        { title: 'Type', field: 'type_chargement.libelle' },
        { title: 'Montant', field: 'montant',
            cellStyle:{textAlign:"right"},
            headerStyle:{textAlign:'right'},
            filtering:false,
            render:rowdata=>util.separteurMillier(rowdata.montant)
        },

        { title: 'Description', field: 'description' },
    ];
    return (
            <Liste table='chargement' 
                values={chargements} 
                setValues={setChargements}
                colonnes={colonnes}
                editable={{
                    onRowUpdate:null,
                    onRowAdd:null
                }}
                actions={[
                    {
                        icon: 'add_circle',
                        iconProps:{style:{fontSize:50,color:green[500]}},
                        tooltip: 'Nouveau chargement',
                        isFreeAction: true,
                        onClick: (event, rowData) => history.push("/chargements")
                    },
                    {
                        icon: 'visibility',
                        iconProps:{color:'primary'},
                        tooltip: 'Afficher chargement',
                        onClick: (event, rowData) => history.push(`/chargements/view/${rowData.id}`)
                    },
                    {
                        icon: 'edit',
                        tooltip: 'Modifier chargement',
                        onClick: (event, rowData) => history.push(`/chargements/${rowData.id}`)
                    },
                ]}

            />
    )
};

